import MenuList from "./MenuList";
import Select, { components } from "react-select";
import React, { useState } from "react";
import "../../../../containers/legal_advice/sections/quick_search/index.scss";

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        border: '1px solid #8533eb',
        boxShadow: 'none',
        borderRadius: 20,
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#000000d9',
        opacity: 0.6,
    }),
    valueContainer: (provided) => ({
        ...provided,
        maxHeight: '35px',
        overflowY: 'auto',
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 100,
    }),
    indicatorsContainer: (provided, state) => ({
        ...provided,
        backgroundColor: '#8533eb',
        borderTopLeftRadius: 20,
        borderBottomLeftRadius: 20,
        color: 'white'
    }),
    dropdownIndicator: (provided, state) => ({
        ...provided,
        color: 'white',
    }),
    clearIndicator: (provided, state) => ({
        ...provided,
        backgroundColor: 'white',
        height: '100%',
        alignItems: 'center',
    }),
    multiValue: (provided, state) => ({
        ...provided,
        width: '70%',
        backgroundColor: 'transparent',
        color: '#000000d9',
    }),
    multiValueLabel: (provided, state) => ({
        ...provided,
        color: '#000000d9',
    }),
    indicatorSeparator: (provided, state) => ({
        ...provided,
        display: 'none',
    }),
};

const ValueContainer = ({ children, ...props }) => {
    const render = () => {
        if (props.selectProps?.value?.length === 0) return children[0];
        if (props.selectProps?.value?.length === 1) return props.selectProps.value[0].label;
        if (props.selectProps?.value?.length > 1) return `נבחרו ${props.selectProps.value.length}`;
    };
    return (
        <components.ValueContainer {...props}>
            <span>{props?.value?.length === 1 && props.value[0].label}</span>
            {render()}
            {children[1]}
        </components.ValueContainer>
    );
};

const MultiSelectWrapper = ({ options, isSearchable, isRtl, isMulti, setValue, placeholder, placeholderText }) => {
    const [selectedLabel, setSelectedLabel] = useState([]);
    const [selectedValue, setSelectedValue] = useState([]);
    const [inputValue, setInputValue] = useState('');

    const handleChange = (selectedOptions) => {
        let currentFilterValues = [];
        let currentFilterLabels = [];

        if (isMulti) {
            selectedOptions.forEach((option) => {
                currentFilterValues.push(option.value);
                currentFilterLabels.push(option.label);
            });
        } else {
            if (selectedOptions) {
                currentFilterValues.push(selectedOptions.value);
                currentFilterLabels.push(selectedOptions.label);
            }
        }

        setSelectedLabel(currentFilterLabels);
        setSelectedValue(currentFilterValues);
        setValue(placeholder, currentFilterValues);
        setInputValue(''); // Clear the input value
    };

    const handleInputChange = (newValue, actionMeta) => {
        if (actionMeta.action === 'input-change') {
            setInputValue(newValue);
        }
    };

    let selectLabel = null;

    if (isMulti) {
        const labelValuePairs = [];

        selectedLabel.forEach((label, index) => {
            labelValuePairs.push({ label, value: selectedValue[index] });
        });

        selectLabel = labelValuePairs;
    } else {
        if (selectedLabel[0] !== undefined) {
            selectLabel = { label: selectedLabel[0], value: selectedValue[0] };
        } else {
            selectLabel = null;
        }
    }

    return (
        <>
            <h3 style={{ color: '#000000d9', marginBottom: 10 }}>{placeholderText}</h3>
            <Select
                options={options}
                isSearchable={isSearchable}
                isMulti={isMulti}
                components={{
                    MenuList: (props) => <MenuList {...props} isMulti={isMulti} />,
                    ...(isMulti && { ValueContainer }),
                }}
                isRtl={isRtl}
                value={selectLabel}
                onChange={handleChange}
                // isDisabled={!options?.length}
                placeholder="בחר"
                styles={customStyles}
                isClearable={true}
                closeMenuOnSelect={false}
                inputValue={inputValue}
                onInputChange={handleInputChange}
            />
        </>
    );
};

export default MultiSelectWrapper;
